import api from './default'

export default api('/api/transcript', 'transcripts')
